import Dialog from '@mui/material/Dialog';
import { Button, Box, Divider, CircularProgress } from '@mui/material';
import { useState, useEffect, FC } from 'react';
import VendorDropdown from '../controls/VendorDropdown';
import { isVendor, Vendor } from 'src/types/vendor';
import { User } from 'src/types/user';
import { Grid, GridCellProps, GridColumn } from '@progress/kendo-react-grid';
import { UnlinkVendorCommandCell } from '../grid/UnlinkVendorCommandCell';
import { post } from 'src/api/Api';

interface LinkVendorDialogProps {
  cancel: () => void;
  onSubmit: (vendorToLink: Vendor, user: User) => void;
  isOpen: boolean;
  user: User;
  chrildren?: React.ReactNode;
}

const LinkVendorDialog: FC<LinkVendorDialogProps> = ({ cancel, onSubmit, isOpen, user }) => {
  const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  const [dialogUser, setDialogUser] = useState<User | null>(null);
  const [linkedVendorData, setLinkedVendorData] = useState<Vendor[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setDialogUser(user);
    setLinkedVendorData(user?.vendors ?? []);
  }, [user]);

  const cancelWithoutSubmit = (e) => {
    e.preventDefault();
    cancel();
  };

  const onChange = (value: NonNullable<string | Vendor>) => {
    if (isVendor(value)) {
      setSelectedVendor(value);
    }
  };

  const unlinkVendor = (vendor: Vendor) => {
    setIsLoading(true);
    post<User>('/UserAdmin/unlinkUserFromVendor', { vendorNumber: vendor.numberString, companyUserId: dialogUser.id })
      .then((vendorUser) => {
        setLinkedVendorData(vendorUser.vendors);
      })
      .catch((err) => {
        console.error('unlinkVendor error', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const MyUnlinkCommandCell = (props: GridCellProps | any) => <UnlinkVendorCommandCell {...props} unlinkVendor={unlinkVendor} />;

  return (
    <Dialog maxWidth={'xs'} fullWidth open={isOpen} onClose={cancel}>
      <div className="px-2">
        <div>
          <p>
            <b>{dialogUser?.name}</b> is currently linked to:
          </p>
        </div>
        {!isLoading && linkedVendorData && linkedVendorData.length > 0 && (
          <Grid data={linkedVendorData} style={{ minHeight: 0, paddingTop: '5px' }} scrollable="none" sortable={false} dataItemKey="number">
            <GridColumn field="name" title="Vendor Name" />
            <GridColumn field="numberString" title="Vendor Number" />
            <GridColumn cell={MyUnlinkCommandCell} />
          </Grid>
        )}
        {isLoading && <CircularProgress />}
      </div>
      <Divider style={{ padding: '15px' }} variant="middle" />
      <Box className="px-2 pb-2">
        <div className="pt-2"></div>
        <b> Link Vendor To User </b>
        <VendorDropdown onChange={onChange} style={{ width: '300px', paddingBottom: '10px' }} vendorsToExclude={dialogUser?.vendors ?? []} />
        <div>
          <Button variant="outlined" onClick={() => onSubmit(selectedVendor, dialogUser)} disabled={selectedVendor == null}>
            Link Vendor
          </Button>
          <Button style={{ marginLeft: '15px' }} onClick={cancelWithoutSubmit} variant="outlined">
            Cancel
          </Button>
        </div>
      </Box>
    </Dialog>
  );
};

export default LinkVendorDialog;
